// extracted by mini-css-extract-plugin
export default {"container":"ProjectsPage_container_dwIXj","content":"ProjectsPage_content_Vb7SL"};